import { render, staticRenderFns } from "./log-delete.vue?vue&type=template&id=0db0e73b&scoped=true&lang=pug&"
import script from "./log-delete.vue?vue&type=script&lang=js&"
export * from "./log-delete.vue?vue&type=script&lang=js&"
import style0 from "./log-delete.vue?vue&type=style&index=0&id=0db0e73b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db0e73b",
  null
  
)

export default component.exports